import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function VolumeIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M14.6063 2C12.1215 2 12.8728 6.25717 4.48768 8.64527C2.16947 9.30394 1 9.80077 1 12.2438V18.7591C1 21.2021 2.16947 21.6989 4.48768 22.3568C12.8728 24.7453 12.1211 29 14.6063 29H15.6857C16.8213 29 17.7432 28.0681 17.7432 26.917V4.085C17.7432 2.93433 16.8213 2 15.6857 2H14.6063Z"
        fill="currentColor"
      />
      <path
        d="M22.0492 8.6606C20.816 8.67513 20.0499 10.0219 20.6542 11.1117C22.1006 13.8138 22.1006 17.185 20.6542 19.8891C20.1994 20.6911 20.4859 21.7138 21.2871 22.1554C22.0883 22.5957 23.0907 22.2801 23.5065 21.4567C25.4871 17.7577 25.4871 13.2398 23.5065 9.54005C23.2215 8.99317 22.6595 8.65172 22.0492 8.6606Z"
        fill="currentColor"
      />
      <path
        d="M26.4724 4.48335C25.167 4.54389 24.4655 6.06546 25.2563 7.11966C26.8132 9.26641 27.7539 12.3112 27.7539 15.4992C27.7539 18.6872 26.8136 21.734 25.2563 23.8787C24.7222 24.6109 24.8764 25.6441 25.5987 26.1825C26.3225 26.7213 27.3401 26.5635 27.8719 25.8293C29.9122 23.0134 31 19.329 31 15.4992C31 11.6711 29.9122 7.987 27.8719 5.17108C27.5498 4.71461 27.0252 4.4559 26.4724 4.48335Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
